<template>
	<div class="flex items-center align-center justify-center h-full w-full">
		<div class="card card-compact bg-base-100 w-96 border">
			<div class="card-body">
				<h2 class="card-title">Login</h2>

				<input
					type="text"
					v-model="correo"
					placeholder="Correo"
					autocomplete="username"
					class="input input-sm input-bordered w-full"
				/>
				<input
					type="password"
					v-model="contra"
					placeholder="Contraseña"
					autocomplete="current-password"
					class="input input-sm input-bordered w-full"
					@keyup.enter="handleLogin"
				/>

				<div class="card-actions justify-end">
					<button
						@click="handleLogin()"
						class="btn btn-primary w-full btn-sm no-animation"
					>
						Login
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { ref } from 'vue'
import { useLoading } from 'vue-loading-overlay'
import { useAuthStore } from '../stores/authStore'
import { useRouter } from 'vue-router'

export default {
	name: 'AdminCatas',
	setup() {
		const loading = useLoading({
			loader: 'spinner'
		})
		const authStore = useAuthStore()
		const router = useRouter()

		const correo = ref(null)
		const contra = ref(null)

		const handleLogin = async () => {
			let loader = loading.show()
			try {
				const data = await authStore.login(correo.value, contra.value)
				console.log('Login successful:', data)

				// Manually check if user has access to current route
				const currentRoute = router.currentRoute.value
				if (!authStore.checkRouteAccess(currentRoute)) {
					console.log('User lacks permission for route:', currentRoute.name)
					alert('No tienes permisos para acceder a esta página')
					await router.push('/')
				} else {
					console.log('User has permission for route:', currentRoute.name)
					// User has permission, stay on current route
				}
			} catch (error) {
				console.error('Login failed:', error)
				alert('Hubo un error: ' + (error.message || 'Error desconocido'))
			} finally {
				loader.hide()
			}
		}

		return {
			handleLogin,
			correo,
			contra
		}
	}
}
</script>
